export const  URLDevelopment = 'https://ecommerce-platform-two-olive.vercel.app'
